<script setup lang="ts">
import SpaceShip from "@/components/MainPage/PcVersion/SpaceShip.vue";
import ScoutsLogo from "@/components/Common/ScoutsLogo.vue";
import GreetingsHolder from "@/components/MainPage/PcVersion/GreetingsHolder.vue";
import RegisterButton2 from "@/components/MainPage/PcVersion/RegisterButton2.vue";
import TestDescription from "@/components/MainPage/PcVersion/TestDescription.vue";
import ReferralProgramDescription from "@/components/MainPage/PcVersion/ReferralProgramDescription.vue";
import ContentHolder from "@/components/MainPage/PcVersion/ContentHolder.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'MainPagePcVersion',
})
</script>

<template>
    <div
        class="main"
    >
        <SpaceShip/>

        <div class="wrapper">
            <ScoutsLogo/>

            <GreetingsHolder/>
            <RegisterButton2/>
            <ContentHolder/>
            <TestDescription/>
            <RegisterButton2/>
            <ReferralProgramDescription/>

            <div class="paddingWorkaround noselect">не, ну это костыль</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    padding: 30px 0 0 0;
    overflow: hidden;
    overflow-y: scroll;

    display: flex;
    justify-content: center;
}

.logo {
    position: relative;
    width: 700px;
}

.wrapper {
    position: relative;
    z-index: 900;
    width: fit-content;

    display: flex;
    flex-direction: column;
    gap: 50px;
    justify-content: flex-start;
    align-items: center;
}

.paddingWorkaround {
    font-size: 1px;
    color: transparent;
}
</style>
